import { studentId } from "../helpers";
const protocol = "https://";
const domain = "api.brooklyndrives.com";

export const studentAppointmentData = async () => {
  return await fetch(
    `${protocol}${domain}/API/api/StudentAppointment/` + studentId
  )
    .then(handleErrors)
    .then(response => {
      return response.json();
    })
    .then(myJson => {
      return myJson;
    });
};

export const studentFiveHourData = async () => {
  return await fetch(`${protocol}${domain}/API/api/FiveHourClass/` + studentId)
    .then(handleErrors)
    .then(response => {
      return response.json();
    })
    .then(myJson => {
      return myJson;
    });
};

export const studentBalanceData = async () => {
  return await fetch(`${protocol}${domain}/API/api/Balance/` + studentId)
    .then(handleErrors)
    .then(response => {
      return response.json();
    })
    .then(myJson => {
      console.log(myJson);
      return myJson;
    });
};

export const studentPaymentData = async () => {
  return await fetch(`${protocol}${domain}/API/api/Payments/` + studentId)
    .then(handleErrors)
    .then(response => {
      return response.json();
    })
    .then(myJson => {
      return myJson;
    });
};

export const packagesData = async () => {
  return await fetch(`${protocol}${domain}/API/api/Packages/` + studentId)
    .then(handleErrors)
    .then(response => {
      return response.json();
    })
    .then(myJson => {
      return myJson;
    });
};

export const basicInfoData = async () => {
  return await fetch(`${protocol}${domain}/API/api/BasicInfo/${studentId}`)
    .then(handleErrors)
    .then(response => response.json())
    .then(myJson => myJson);
};

// Handle HTTP errors since fetch won't.
const handleErrors = response => {
  if (!response.ok) {
    console.log(response.statusText);
  }
  return response;
};
